import { defineInlineEdit } from "../../../../components/MobileList/inlineEdit";

/**
 * views/notification/from submits the whole form on edit, and the slice's
 * setById only repopulates `{id, title, description, target_users}` — so the
 * dialog has always sent the audience fields (`users`, `groups`, `is_all*`)
 * back at their empty initial values. Reproducing that keeps an inline save
 * identical to a dialog save rather than inventing a different contract.
 *
 * Only the two text fields get a pencil; the audience is chosen once when the
 * notification is composed.
 */
export default defineInlineEdit({
  api: "notification",
  hydrate: false,
  toPayload: (source) => ({
    id: source.id,
    title: source.title ?? "",
    description: source.description ?? "",
    target_users: source.target_users,
    users: [],
    groups: [],
    is_all: false,
    is_all_rep: false,
    is_all_pos: false,
  }),
  fields: {
    title: { label: "العنوان", type: "text", required: true },
    description: { label: "الوصف", type: "multiline", required: true },
  },
});
